import { useEffect } from 'react';
import { Link } from 'react-router-dom';
import MobileView from '@app/story/ViewStory/mobileView';
import WebView from '@app/story/ViewStory/webView';
import DailyAdventures from '@assets/images/Daily_adventures.png';
import NightWhisperImg from '@assets/images/Night_whisper.png';
import Icon from '@assets/images/ai5.png';
import CreateNewStory from '@assets/images/create-new-story.png';
import SuggestIcon from '@assets/images/feedback-img.png';
import NewHome from '@assets/images/new-home.png';
import OurLibrary from '@assets/images/our-library.png';
import SelectEnding from '@assets/images/select-ending.png';
import WhatIf from '@assets/images/what-if.png';
import YouTellStory from '@assets/images/you-tell-story.png';
import { StoryLoading, Col, Row } from '@components';
import {
  getMobileStoryDetailsTransformer,
  getStoryDetailsTransformer,
} from '@coreStory/transformer';
import { IStoryList } from '@coreStory/type';
import { useGetSuggestedStory } from '@coreStory/useCase';
import cs from 'classnames';
import styles from './index.module.scss';
import { useStore } from '@store';

const WebDashboard = () => {
  const width = window.innerWidth;
  const { mutate, data, isLoading } = useGetSuggestedStory();
  const { theme } = useStore();
  useEffect(() => {
    mutate();
  }, []);

  return (
    <div className={styles['dashboard_layout']}>
      <Row
        gutter={[20, 20]}
        className={styles['dashboard_items_container']}
        align={'stretch'}>
        <Col lg={14} xs={24}>
          <Link to={'./tadatoonLibrary#Nights_whisper'}>
            <div className={styles['night_whisper']}>
              <img src={Icon} alt="" className={styles['icon']} />
              <img
                src={theme === 'day' ? DailyAdventures : NightWhisperImg}
                alt="Night Whisper"
              />
              <h1
                className={cs([
                  styles['title'],
                  theme === 'day' ? styles['title_purple'] : '',
                ])}>
                {theme === 'night' ? 'Night’s whisper' : 'Daily adventures'}
              </h1>
              <h2
                className={cs([
                  styles['description'],
                  theme === 'day' ? styles['title_purple'] : '',
                ])}>
                A World of Imagination for Your Kids!
              </h2>
              {/* <div className={styles['toggle']}>
                <ToggleStory />
              </div> */}
            </div>
          </Link>
        </Col>
        <Col lg={10} xs={24}>
          <Row
            gutter={[10, 10]}
            style={{ alignItems: 'stretch', height: '100%' }}>
            <Col lg={24} sm={8} xs={24}>
              <Link to={'/story'} className={styles['action_cards']}>
                <img src={CreateNewStory} alt="create new story" />
                <h3>Create Story</h3>
              </Link>
            </Col>
            <Col lg={24} sm={8} xs={24}>
              <Link to={'./tadatoonLibrary'} className={styles['action_cards']}>
                <img src={OurLibrary} alt="Tadatoon Library" />
                <h3>Tadatoon Library</h3>
              </Link>
            </Col>
            <Col lg={24} sm={8} xs={24}>
              <Link
                to={'./library#New_home_new_story'}
                className={styles['action_cards']}>
                <img src={NewHome} alt="New Home, New Story" />
                <h3>New Home, New Story</h3>
              </Link>
            </Col>
          </Row>
        </Col>
      </Row>
      <Row gutter={[20, 20]} align={'stretch'}>
        <Col sm={8} xs={24}>
          <Link
            to={'#'}
            className={cs([styles['colored_cards'], styles['pink']])}>
            <img src={SelectEnding} alt="Select your ending" />
            <h3>Select your ending</h3>
          </Link>
        </Col>
        <Col sm={8} xs={24}>
          <Link
            to={'/dashboard/whatif'}
            className={cs([styles['colored_cards'], styles['yellow']])}>
            <img src={WhatIf} alt="What if" />
            <h3>What if</h3>
          </Link>
        </Col>
        <Col sm={8} xs={24}>
          <Link
            to={'/dashboard/tell-story'}
            className={cs([styles['colored_cards'], styles['orange']])}>
            <img src={YouTellStory} alt="You tell story" />
            <h3>You tell story</h3>
          </Link>
        </Col>
      </Row>

      {isLoading ? (
        <div className={styles['suggested_story']}>
          <StoryLoading />
        </div>
      ) : data?.length ? (
        <div className={styles['suggested_story']}>
          <div className={styles['title']}>
            <img src={SuggestIcon} alt="" />
            <h2>Tadatoon suggested story</h2>
          </div>
          <div className={styles['']}>
            <h1
              className="text-pink"
              style={{
                textAlign: 'center',
              }}>
              {data[0]?.StoryName}
            </h1>
          </div>
          {width > 1000 ? (
            <WebView
              storyData={getStoryDetailsTransformer(data as IStoryList[])}
            />
          ) : (
            <MobileView
              storyData={getMobileStoryDetailsTransformer(data as IStoryList[])}
            />
          )}
        </div>
      ) : null}
    </div>
  );
};

export default WebDashboard;
